export const id = 'new-agreement';

export type Params = Record<string, string | undefined>;
export type LoaderData = null;

export default async function loader(): Promise<LoaderData> {
  return null;
}
